import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BASE_URL_PREMOCENTER_FRONT } from 'app/app.constants';
import { Clientes } from 'app/interfaces/Cliente';
import { Permissoes } from 'app/interfaces/permissoes';
import { ClienteService } from 'app/services/cliente/cliente.service';
import { PermissoesService } from 'app/services/permissoes/permissoes.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-redirecionamento',
  standalone: true,
  imports: [],
  templateUrl: './redirecionamento.component.html',
  styleUrl: './redirecionamento.component.css'
})
export class RedirecionamentoComponent {
    public readonly URL_PREMOCENTER_FRONT: string = BASE_URL_PREMOCENTER_FRONT;

  constructor(
    private activatedRoute: ActivatedRoute,
    private permissoesService: PermissoesService,
    private clienteService: ClienteService
  ) { }

  ngOnInit(): void {
    this.armazenarDadosUsuario();
  }

  public buscarPermissoesUsuario(): void {
    const permissoesDados: Observable<Permissoes> = this.permissoesService.buscarPermissoes();
    permissoesDados.subscribe({
      next: (permissoes: any) => {
        localStorage.setItem('usuarioId', JSON.stringify(permissoes.usuarioId));
        localStorage.setItem('usuarioNome', permissoes.usuarioNome);
        localStorage.setItem('usuarioLogin', permissoes.usuarioLogin);
        localStorage.setItem('permissoes', JSON.stringify(permissoes.permissoes));
        this.buscarClientesUsuario();
      },
    });
  }

  public buscarClientesUsuario(): void {
    const clientes: Observable<Clientes> = this.clienteService.buscarClientesUsuario();
    clientes.subscribe((clientes) => {
      var horaEntrada = Date.now();
      sessionStorage.setItem('clientes', JSON.stringify(clientes))
      this.redirecionarUsuario(horaEntrada);
    });
  }

  public armazenarDadosUsuario(): void {
    const TOKEN: string = this.activatedRoute.snapshot.paramMap.get('token')!;
    localStorage.setItem('token', TOKEN);

    this.buscarPermissoesUsuario();
  }

  public redirecionarUsuario(horaEntrada: number): void {
    const TEMPO_ESPERA: number = 2600 - (Date.now() - horaEntrada);
    const PERMISSOES_USUARIO: string[] = this.permissoesService.getPermissoesLocalStorage();

    setTimeout(() => {
      if (PERMISSOES_USUARIO.includes('acessar_premoplan')) {
        window.location.href = '/premoplan';
      } else {
        window.location.href = this.URL_PREMOCENTER_FRONT;
      }
    }, TEMPO_ESPERA);
  }
}
